if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header-wrapper');
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          liveRegion: this.querySelector('#sr-country-search-results'),
          closeBtn: this.querySelector('.close-country-selector'),
        };
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
        if (this.elements.closeBtn && this.elements.panel && this.elements.button) {
          this.elements.closeBtn.addEventListener('click', () => {
            this.elements.panel.setAttribute('hidden', '');
            this.elements.button.setAttribute('aria-expanded', 'false');
            document.body.classList.remove('overflow-hidden-mobile');
            const sidebarWrapper = document.querySelector('.halo-sidebar_menu');
            if (sidebarWrapper) {
              sidebarWrapper.classList.remove('country-selector-open');
            }
          });
        }
      }
      
      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
        document.body.classList.remove('overflow-hidden-mobile');
        document.querySelector('.halo-sidebar_menu ').classList.add('country-selector-open');
        // this.header.preventHide = false;
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
    }

     openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      const isExpanded = this.elements.button.getAttribute('aria-expanded') === 'false';
      this.elements.button.setAttribute('aria-expanded', isExpanded.toString());
    
      if (!document.body.classList.contains('overflow-hidden-tablet')) {
        document.body.classList.add('overflow-hidden-mobile');
      }
    
      if (this.hasAttribute('data-prevent-hide')) {
        // this.header.preventHide = true;
      }
    
      if (isExpanded) {
        document.querySelector('.halo-sidebar_menu ')?.classList.add('country-selector-open');
      } else {
        document.querySelector('.halo-sidebar_menu ')?.classList.remove('country-selector-open');
      }
}



    }
  );
}
